import { useTheme } from '@mui/material'
import { TextFieldWithDarkMode } from 'dark-mode-components'

const MaxTemperatureInputField = ({
  temperature,
  maxTemperature,
  setMaxTemperature,
  isDarkBackdrop,
}: {
  temperature: number
  maxTemperature: number
  setMaxTemperature: (maxTemperature: number) => void
  isDarkBackdrop: boolean // used to conditionally style label text color, sometimes this component is on a light / dark backdrop
}) => {
  const theme = useTheme()

  const onMaxTemperatureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMaxTemperature(Number(event.target.value))
  }

  const isTempGreaterThanMaxTemp = temperature > maxTemperature
  const isMaxTemperatureTooHigh = maxTemperature > 5

  const error = isTempGreaterThanMaxTemp || isMaxTemperatureTooHigh

  const getHelperText = () => {
    if (isTempGreaterThanMaxTemp) {
      return 'Max temperature cannot be less than temperature'
    } else if (isMaxTemperatureTooHigh) {
      return 'Please use a max temperature less than 5'
    } else {
      return null
    }
  }

  return (
    <TextFieldWithDarkMode
      className="has-label"
      theme={theme}
      isDarkBackdrop={isDarkBackdrop}
      inputProps={{
        min: 0,
        step: 0.1,
      }}
      type="number"
      label="Max temperature"
      value={maxTemperature}
      onChange={onMaxTemperatureChange}
      error={error}
      helperText={getHelperText()}
      sx={{
        width: '240px',
      }}
    />
  )
}

export default MaxTemperatureInputField
